import { getEnvironmentVariable } from "../../../global/environmentVariables";

const IS_DEV = getEnvironmentVariable("IS_DEV") === "true";
const IS_GW = getEnvironmentVariable("COMPANY_FLAG") === "gw";

// Taken from the Cookie Policy
export const cookieTypes = [
  {
    id: "essential",
    name: "Essential Cookies",
    description:
      "Necessary for the operation of key services. We may use essential cookies to authenticate users, prevent fraudulent use of user accounts, or offer core features of our services.",
  },
  {
    id: "analytical",
    name: "Analytical Cookies",
    description:
      "Allows us to recognize and count the number of visitors and see how visitors move around the services. This helps us improve the way the services work.",
  },
  {
    id: "performance",
    name: "Performance Cookies",
    description:
      "Allows us to use caching of regularly accessed data that provides better services performance to all our users.",
  },
  {
    id: "informational",
    name: "Informational Cookies",
    description:
      "Allows us to recognize you when you return to our services. This enables us to personalize our content for you, greet you by name, and remember your preferences (for example, your choice of language or region).",
  },
];

export const cookies = [
  {
    name: "CookieConsent",
    purpose: "essential",
    expiration: "30 days",
  },
  {
    name: "affiliate",
    purpose: "analytical",
    expiration: "30 days",
  },
  {
    name: "referralCode",
    purpose: "analytical",
    expiration: "60 days",
  },
  {
    name: "rankingsRegion",
    purpose: "performance",
    expiration: "30 days",
  },
  {
    name: "lastEventId",
    purpose: "analytical",
    expiration: "30 days",
  },
  {
    name: "lastListId",
    purpose: "analytical",
    expiration: "30 days",
  },
];

export const localStorageVars = [
  {
    name: "AuthIdentityServiceProvider.web-app.LastAuthUser",
    purpose: "essential",
    expiration: "Does not expire",
  },
  {
    name: "AuthIdentityServiceProvider.web-app.accessToken",
    purpose: "essential",
    expiration: "On logout",
  },
  {
    name: "AuthIdentityServiceProvider.web-app.idToken",
    purpose: "essential",
    expiration: "On logout",
  },
  {
    name: "AuthIdentityServiceProvider.web-app.refreshToken",
    purpose: "essential",
    expiration: "On logout",
  },
  {
    name: "locale",
    purpose: "essential",
    expiration: "Does not expire",
  },
  {
    name: "GWMyWarhammerDismissed",
    purpose: "performance",
    expiration: "12 hours",
  },
  {
    name: "[]Rows",
    purpose: "informational",
    expiration: "Does not expire",
  },
  {
    name: "CachedItems",
    purpose: "essential",
    expiration: "Does not expire",
  },
  {
    name: "distanceType",
    purpose: "performance",
    expiration: "Does not expire",
  },
  {
    name: "gameSystems",
    purpose: "performance",
    expiration: "Does not expire",
  },
  {
    name: "cartState",
    purpose: "essential",
    expiration: "End of session",
  },
  {
    name: "loyaltyPoints",
    purpose: "performance",
    expiration: "Does not expire",
  },
  {
    name: "defaultRegionLastFetched",
    purpose: "performance",
    expiration: "1 day",
  },
  {
    name: "profileImage",
    purpose: "performance",
    expiration: "Does not expire",
  },
  {
    name: "bcpRedirectUrl",
    purpose: "essential",
    expiration: "End of session",
  },
  {
    name: "bcpState",
    purpose: "essential",
    expiration: "End of session",
  },
  {
    name: "themeMode",
    purpose: "essential",
    expiration: "End of session",
  },
  {
    name: "roster",
    purpose: "performance",
    expiration: "Does not expire",
  },
  {
    name: "rosterData",
    purpose: "performance",
    expiration: "Does not expire",
  },
  {
    name: "placings",
    purpose: "performance",
    expiration: "Does not expire",
  },
  {
    name: "placingsData",
    purpose: "performance",
    expiration: "Does not expire",
  },
  {
    name: "eventSearchCache",
    purpose: "informational",
    expiration: "Does not expire",
  },
  {
    name: "leaderboardRedesign",
    purpose: IS_GW || IS_DEV ? "essential" : "informational",
    expiration: "Does not expire",
  },
  {
    name: "eventsMapToggle",
    purpose: "informational",
    expiration: "Does not expire"
  }
];

export const sessionStorageVars = [
  {
    name: "appMode",
    purpose: "essential",
    expiration: "End of session",
  },
  {
    name: "bcpIndex",
    purpose: "essential",
    expiration: "End of session",
  },
  {
    name: "bcpHistory",
    purpose: "essential",
    expiration: "End of session",
  },
  {
    name: "ratelimit-reset",
    purpose: "essential",
    expiration: "End of session",
  },
  {
    name: "dataDog",
    purpose: "analytical",
    expiration: "End of session",
  },
  {
    name: "googleAnalytics",
    purpose: "analytical",
    expiration: "End of session",
  },
  {
    name: "bugSnag",
    purpose: "analytical",
    expiration: "End of session",
  },
  {
    name: "stripe_session",
    purpose: "essential",
    expiration: "End of session",
  },
];
